module.exports = __webpack_public_path__ + "img/AZ.c6518423.png";